export const maxPlayersOptions = (): {
  value: string | number;
  label: string;
}[] => {
  return [...Array(8)].map((_, i) => ({
    value: i + 2,
    label: `${i + 2} players`,
  }));
};
